SelectBox = App.loadClass "core::SelectBox"
CancelDialog = App.loadClass "core::CancelDialog"

class exports.RuppOrdersHandler extends Handler
    init: () ->
        @layoutUrl = 'backend/grower/rupp-orders/load-layout'
        @layoutSelector = App.sidebar.contentDiv()

        @subHandlers =
            'Orders_Delete':
                class: 'grower::handlers/rupp_orders/RuppOrdersDeleteDialogHandler'

        @loadLayout()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        ###########################
        # View/Edit order filters
        ###########################
        $('#orders_year_filter').bind 'change', () =>
            @filterCrop()
            @filterOrder()

        $('#orders_crop_filter').bind 'change', @filterOrder

        $('#orders_order_filter').bind 'change', () ->
            if $(this).val()
                $('.orders-filter-btn').removeClass('disabled')
            else
                $('.orders-filter-btn').addClass('disabled')

        if not @taffyObjects["orders"]?
            @taffyObjects["orders"] = TAFFY([])

        years = @taffyObjects['orders']().order('year').distinct('year', 'year')
        crops = @taffyObjects['orders']().order('crops_id').distinct('crops_id', 'crop')
        orders = @taffyObjects['orders']().order('orders_id').distinct('orders_id', 'orders_id')

        SelectBox.render years, $('#orders_year_filter')
        SelectBox.render crops, $('#orders_crop_filter')
        SelectBox.render orders, $('#orders_order_filter')

        $('#btn_view_order').bind 'click', () =>
            if $('#orders_order_filter').val()
                @view_dlg = @createSubHandler('grower::handlers/rupp_orders/RuppOrdersDialogHandler')
                if @view_dlg
                    @view_dlg.loadLayoutPostOptions = 'order_id': $('#orders_order_filter').val()
                    @view_dlg.init()
                    App.sidebar.element.find('.map_sidebar_hide').click()

        $('#btn_del_order').bind 'click', () =>
            ths = this
            order_id = $('#orders_order_filter').val()
            dlg = new CancelDialog()
            if dlg
                dlg.saveUrl = 'backend/grower/rupp-orders/cancel-order'
                dlg.saveData = { id: order_id }
                dlg.destroyOnYes = false
                dlg.setContent
                    title: "Cancel Order"
                    body: "Are you sure you wish to cancel this Order? This action cannot be undone.<div class='message_writer'></div>"
                    yes: "Cancel Order"
                    no: "Go Back"

                dlg.successAction = () =>
                    @removeFromTaffy(order_id)

                dlg.createDialog()
                dlg.on "cancel:yes", () ->
                    @dialog.find('.message_writer').message_writer().message_writer('info', 'Cancelling...')
                    @save()

                    # If deleted order is being viewed close the view dlg
                    if ths.view_dlg?.loadLayoutPostOptions.order_id is order_id
                        ths.view_dlg.destroy()


        ###########################
        # Add new order button
        ###########################
        $('#orders_crop_add').bind 'change', () ->
            if $(this).val()
                $('#btn_add_order').removeClass('disabled')
            else
                $('#btn_add_order').addClass('disabled')

        $("#btn_add_order").bind 'click', () =>
            if $('#orders_crop_add').val()
                dlg = @createSubHandler('grower::handlers/rupp_orders/RuppOrdersDialogHandler')
                if dlg
                    dlg.loadLayoutPostOptions = 'crops_id': $('#orders_crop_add').val()
                    dlg.init()
                    App.sidebar.element.find('.map_sidebar_hide').click()


    removeFromTaffy: (orders_id) ->
        @taffyObjects['orders'](
            'orders_id':
                '==': orders_id
        ).remove()
        @filterOrder()


    filterCrop: () =>
        year = $('#orders_year_filter').val()

        filter = {}
        filter.year = { '==': year } if year
        validCrops = @taffyObjects['orders'](filter).distinct('crops_id', 'crop')
        SelectBox.render validCrops, $('#orders_crop_filter')


    filterOrder: () =>
        year = $('#orders_year_filter').val()
        crop = $('#orders_crop_filter').val()

        filter = {}
        filter.year = { '==': year } if year
        filter.crops_id = { '==': crop } if crop

        validOrders = @taffyObjects['orders'](filter).order('orders_id').distinct('orders_id', 'orders_id')
        SelectBox.render validOrders, $('#orders_order_filter')


    orderCompleted: () =>
        @init()
